module.exports = __webpack_public_path__ + "static/img/2.cd0eeda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/2/2.png
// module id = ywWT
// module chunks = 1